import auth from '../../../utils/auth'
import { HELP_ICON_HTML } from '../../tourUi'
import { restoreExportacaoTourDemo } from '../../../containers/ExportacaoDados/components/CamposGrupos'

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))

const isClienteUser = () => auth.getUserInfo()?.tipo === 'cliente'

const activateTab = async (tabName) => {
    const selector = tabName === 'parametros'
        ? '[data-tour="exportacao-tab-parametros"]'
        : '[data-tour="exportacao-tab-gerar"]'
    const tab = document.querySelector(selector)

    if (tab && tab.getAttribute('aria-selected') !== 'true' && !tab.classList.contains('react-tabs__tab--selected') && !tab.classList.contains('react-tabs__tab--disabled')) {
        tab.click()
        await delay(tabName === 'parametros' ? 400 : 250)
    }
}

const moveToTabAndNext = (tourManager, tabName) => {
    tourManager.setHighlightVisible?.(false)
    activateTab(tabName).then(() => {
        tourManager.moveNext()
        tourManager.setHighlightVisible?.(true)
        tourManager.driverObj?.refresh?.()
    })
}

const moveToTabAndPrevious = (tourManager, tabName) => {
    tourManager.setHighlightVisible?.(false)
    activateTab(tabName).then(() => tourManager.movePrevious())
}

const findModalButton = (labelPattern) => Array.from(document.querySelectorAll('.modal.show button'))
    .find((button) => labelPattern.test(button.textContent || ''))

const openParametrosModal = async (tourManager) => {
    tourManager.exportacaoParamModalLock = true

    if (document.querySelector('.modal.show [data-tour="exportacao-param-body"], .modal.show [data-tour="exportacao-param-cliente"]')) {
        return
    }

    document.querySelector('[data-tour="exportacao-gerenciar-parametros"]')?.click()

    try {
        await tourManager.waitForElement('[data-tour="exportacao-param-body"], .modal.show [data-tour="exportacao-param-cliente"]', 4000)
    } catch (error) {}

    await delay(200)
}

const closeParametrosModal = (tourManager) => {
    const cancelButton = findModalButton(/cancelar/i)

    if (cancelButton) {
        cancelButton.click()
    } else {
        document.querySelector('.modal.show .close')?.click()
    }

    if (tourManager) tourManager.exportacaoParamModalLock = false
}

const hasParametrosSelecionadosNoModal = () => Boolean(
    document.querySelector('[data-tour="exportacao-param-selecionados"] .hdv-multi-report-item, #multi-item-selected .hdv-multi-report-item')
)

const hasEstruturaReal = () => Boolean(document.querySelector('[data-tour="exportacao-estrutura"][data-preenchido="true"]'))

const isTourDemoVisible = () => Boolean(document.querySelector('[data-tour="exportacao-estrutura"][data-tour-demo="true"]'))

export const restoreTourDemoLayout = () => {
    const cancelButton = Array.from(document.querySelectorAll('.modal.show button'))
        .find((button) => /cancelar/i.test(button.textContent || ''))

    if (cancelButton) {
        cancelButton.click()
    } else {
        document.querySelector('.modal.show [data-tour="exportacao-param-modal"] .close, .modal.show .close')?.click()
    }

    document.dispatchEvent(new CustomEvent('hdv-tour-exportacao-demo', { detail: { action: 'restore' } }))
    restoreExportacaoTourDemo()
}

const applyTourDemoLayout = async (tourManager) => {
    if (hasEstruturaReal() || isTourDemoVisible()) return

    document.dispatchEvent(new CustomEvent('hdv-tour-exportacao-demo', { detail: { action: 'apply' } }))

    try {
        await tourManager.waitForElement('[data-tour="exportacao-agrupar"], [data-tour="exportacao-estrutura"][data-tour-demo="true"]', 2500)
    } catch (error) {}

    await delay(200)
}

const leaveParametrosModal = async (tourManager) => {
    closeParametrosModal(tourManager)
    await delay(220)

    if (!hasEstruturaReal()) {
        await applyTourDemoLayout(tourManager)
    }
}

const ensureEstruturaVisivel = async (tourManager) => {
    if (hasEstruturaReal() || isTourDemoVisible()) return

    if (document.querySelector('.modal.show [data-tour="exportacao-param-body"]')) {
        await leaveParametrosModal(tourManager)
        return
    }

    await applyTourDemoLayout(tourManager)
}

const bindClickToAdvance = (element, tourManager, beforeAdvance) => {
    if (!element || element._hdvTourAdvance) return

    const onClick = () => {
        unbindClickToAdvance(element)

        const advance = async () => {
            if (typeof beforeAdvance === 'function') {
                await beforeAdvance()
            } else {
                await delay(220)
            }

            if (tourManager.isActive()) tourManager.moveNext()
        }

        advance()
    }

    element.addEventListener('click', onClick)
    element._hdvTourAdvance = onClick
}

const unbindClickToAdvance = (element) => {
    if (!element?._hdvTourAdvance) return

    element.removeEventListener('click', element._hdvTourAdvance)
    element.removeEventListener('click', element._hdvTourAdvance, true)
    delete element._hdvTourAdvance
}

const bindMinimizeOnShowAviso = (tourManager) => {
    unbindMinimizeOnShowAviso(tourManager)

    const handleShowAviso = () => {
        unbindMinimizeOnShowAviso(tourManager)
        if (tourManager.isActive()) tourManager.minimize()
    }

    tourManager._exportacaoAvisoMinimize = handleShowAviso
    document.addEventListener('showAviso', handleShowAviso)
}

const unbindMinimizeOnShowAviso = (tourManager) => {
    if (!tourManager?._exportacaoAvisoMinimize) return
    document.removeEventListener('showAviso', tourManager._exportacaoAvisoMinimize)
    tourManager._exportacaoAvisoMinimize = null
}

export const buildNovoExportacaoFormSteps = (tourManager, { indiceNovoStep } = {}) => {
    const steps = [
        {
            element: '[data-tour="exportacao-descricao"]',
            popover: {
                title: 'Descrição',
                description: 'Dê um nome fácil de reconhecer. É assim que este relatorio será apresentado na lista.',
                side: 'bottom',
                align: 'start',
                ...(Number.isInteger(indiceNovoStep)
                    ? {
                        onPrevClick: () => {
                            tourManager.navigateAndWait('/exportacao-dados', '[data-tour="exportacao-novo"]', indiceNovoStep, 'novo-exportacao-dados')
                                .then(() => tourManager.moveTo(indiceNovoStep))
                                .catch(() => {})
                        },
                    }
                    : {}),
            },
        },
    ]

    if (!isClienteUser()) {
        steps.push({
            element: '[data-tour="exportacao-cliente"]',
            popover: {
                title: 'Cliente',
                description: 'O relatorio pode ser vinculado a um cliente. Isso ajuda a filtrar os parâmetros na hora de montar a planilha',
                side: 'bottom',
                align: 'start',
            },
        })
    }

    steps.push({
        element: '[data-tour="exportacao-salvar"]',
        popover: {
            title: 'Salvar o modelo',
            description: `Clique em <strong>Salvar</strong> para criar o relatório.<br><br>Depois de salvar, <strong>edite o relatório</strong> para acessar as opções de configuração da planilha, como colunas, cabeçalho e grupos. Em seguida, clique novamente no ícone de <strong>Ajuda</strong> ${HELP_ICON_HTML} para iniciar o guia dessa etapa.`,
            side: 'top',
            align: 'end',
            onPrevClick: () => tourManager.movePrevious(),
        },
        onHighlighted: () => bindMinimizeOnShowAviso(tourManager),
        onDeselected: () => unbindMinimizeOnShowAviso(tourManager),
    })

    return steps
}

export const buildEditarExportacaoFormSteps = (tourManager) => {
    const formSteps = [
        {
            element: '[data-tour="exportacao-abas"]',
            tab: 'gerar',
            popover: {
                title: 'Abas',
                description: 'Nesta tela, você encontrará duas abas:<br><br><strong>Parâmetros e Grupos:</strong> defina os dados e a estrutura da planilha.<br><br><strong>Gerar Relatório:</strong> escolha o período e gere o arquivo.<br><br>Vamos começar por <strong>Parâmetros e Grupos</strong>.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => moveToTabAndNext(tourManager, 'parametros'),
            },
        },
        {
            element: '[data-tour="exportacao-gerenciar-parametros"]',
            tab: 'parametros',
            popover: {
                title: 'Gerenciar Parâmetros',
                description: 'É por aqui que você escolhe o que vai alimentar a planilha. Clique em <strong>Gerenciar Parâmetros</strong> ou em <strong>Próximo</strong> para abrir a seleção.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    unbindClickToAdvance(document.querySelector('[data-tour="exportacao-gerenciar-parametros"]'))
                    tourManager.exportacaoParamModalLock = true
                    openParametrosModal(tourManager).then(() => tourManager.moveNext())
                },
                onPrevClick: () => moveToTabAndPrevious(tourManager, 'gerar'),
            },
            onHighlighted: (element) => bindClickToAdvance(element, tourManager, async () => {
                tourManager.exportacaoParamModalLock = true
                await openParametrosModal(tourManager)
            }),
            onDeselected: (element) => unbindClickToAdvance(element),
        },
        {
            element: '[data-tour="exportacao-param-body"]',
            tab: 'parametros',
            ensureItem: (activeTourManager) => openParametrosModal(activeTourManager),
            popover: {
                title: 'Seleção dos dados',
                description: 'Aqui você define quais dados farão parte da exportação: o <strong>cliente</strong>, o <strong>monitorado</strong> e os <strong>parâmetros</strong> que serão utilizados.<br><br>Para que as opções apareçam, o cliente precisa ter um monitorado com pelo menos um parâmetro vinculado.',
                side: 'left',
                align: 'start',
                onPrevClick: () => {
                    closeParametrosModal(tourManager)
                    setTimeout(() => tourManager.movePrevious(), 280)
                },
            },
        },
        {
            element: '[data-tour="exportacao-param-cliente"]',
            tab: 'parametros',
            ensureItem: (activeTourManager) => openParametrosModal(activeTourManager),
            popover: {
                title: 'Cliente',
                description: 'Escolha o cliente.',
                side: 'right',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-param-monitorado"]',
            tab: 'parametros',
            ensureItem: (activeTourManager) => openParametrosModal(activeTourManager),
            popover: {
                title: 'Monitorado',
                description: 'Em seguida, escolha o monitorado desse cliente. Só aparecem monitorados já cadastrados para ele.',
                side: 'right',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-param-lista"]',
            tab: 'parametros',
            ensureItem: (activeTourManager) => openParametrosModal(activeTourManager),
            popover: {
                title: 'Parâmetros do monitorado',
                description: 'Esta lista mostra os parâmetros vinculados ao monitorado escolhido. Use <strong>+</strong> ou <strong>Selecionar todos</strong> para incluí-los no relatório.',
                side: 'right',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-param-selecionados"]',
            tab: 'parametros',
            ensureItem: (activeTourManager) => openParametrosModal(activeTourManager),
            popover: {
                title: 'Parâmetros escolhidos',
                description: 'Aqui ficam os parâmetros que vão alimentar a planilha. Remova algum se incluir por engano.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-param-acoes"]',
            tab: 'parametros',
            ensureItem: (activeTourManager) => openParametrosModal(activeTourManager),
            popover: {
                title: 'Confirmar a seleção',
                description: 'Após escolher os parâmetros, clique em <strong>Concluir</strong> para salvar a seleção e utilizá-la na planilha.<br><br>Se estiver apenas acompanhando o guia, clique em <strong>Próximo</strong> para continuar. O exemplo usado durante o guia não será salvo no cadastro.',
                side: 'top',
                align: 'end',
                onNextClick: () => {
                    leaveParametrosModal(tourManager).then(() => tourManager.moveNext())
                },
            },
            onHighlighted: (element) => {
                const concluirButton = findModalButton(/concluir/i) || element
                if (!concluirButton || concluirButton._hdvTourAdvance) return

                const onClick = (event) => {
                    if (!hasParametrosSelecionadosNoModal()) {
                        event.preventDefault()
                        event.stopPropagation()
                        event.stopImmediatePropagation?.()
                        unbindClickToAdvance(concluirButton)
                        leaveParametrosModal(tourManager).then(() => {
                            if (tourManager.isActive()) tourManager.moveNext()
                        })
                        return
                    }

                    unbindClickToAdvance(concluirButton)
                    tourManager.exportacaoParamModalLock = true
                    tourManager.waitForElement('[data-tour="exportacao-estrutura"][data-preenchido="true"]', 4000)
                        .catch(() => {})
                        .then(() => delay(280))
                        .then(() => {
                            tourManager.exportacaoParamModalLock = false
                            if (tourManager.isActive()) tourManager.moveNext()
                        })
                }

                concluirButton.addEventListener('click', onClick, true)
                concluirButton._hdvTourAdvance = onClick
            },
            onDeselected: () => {
                unbindClickToAdvance(findModalButton(/concluir/i))
            },
        },
        {
            element: '[data-tour="exportacao-agrupar"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Agrupar dados',
                description: 'Define como os dados serão organizados na planilha.<br><br><strong>Fixo:</strong> mantém os dados conforme o intervalo escolhido na geração.<br><br><strong>Hora, Dia, Mês ou Ano:</strong> agrupa as leituras por esse período, deixando a planilha mais resumida.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        {
            element: '[data-tour="exportacao-separador"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Separador numérico',
                description: 'Define como os números serão exibidos no arquivo.<br><br><strong>Padrão:</strong> usa ponto para separar as casas decimais, como 1,234.56.<br><br><strong>Português (Brasil):</strong> usa vírgula para separar as casas decimais, como 1.234,56.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-periodo-todo"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Exibir dados pelo período todo',
                description: 'Define como as leituras serão apresentadas na planilha.<br><br>Quando ativado, a planilha mostra as leituras de todo o período escolhido.<br><br>Quando desativado, cada parâmetro mostra o valor inicial e final do período, e as opções de escala ficam disponíveis.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-escalas"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Escalas',
                description: 'Este bloco aparece quando <strong>Exibir dados pelo período todo</strong> está desativado.<br><br>Para cada parâmetro, você pode adicionar os valores <strong>mínimo</strong>, <strong>médio</strong> ou <strong>máximo</strong> do período, além dos valores inicial e final.<br><br>Durante o guia, a tabela pode apresentar um parâmetro de exemplo. No seu modelo, serão exibidos os parâmetros selecionados anteriormente.',
                side: 'top',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-colunas-quantidade"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Quantidade de colunas',
                description: 'Informe quantas colunas você deseja ter na tabela. A plataforma criará as colunas abaixo para você configurar.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-coluna-item"], [data-tour="exportacao-colunas"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Conteúdo da coluna',
                description: 'Cada coluna pode receber um parâmetro, uma fórmula ou um valor fixo.<br><br><strong>Parâmetro:</strong> usa um dado selecionado anteriormente, como valor inicial, final ou escala.<br><br><strong>Fórmula:</strong> permite criar um cálculo usando os parâmetros escolhidos. Você define a fórmula que precisa e o resultado do cálculo será exibido na planilha.<br><br><strong>Valor fixo:</strong> repete um texto ou número em todas as linhas, como uma unidade ou observação.<br><br>O ícone de <strong>lápis</strong> permite alterar o nome da coluna no cabeçalho da planilha.',
                side: 'top',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-cabecalho"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Tamanho do cabeçalho',
                description: 'O cabeçalho é a parte de cima da planilha, antes dos dados. Defina quantas <strong>linhas</strong> e <strong>colunas</strong> ele terá. Depois você preenche o texto de cada célula.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-cabecalho-grade"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Células do cabeçalho',
                description: 'Aqui você define as informações que aparecerão no cabeçalho da planilha, como título, unidade ou período.<br><br>Você também pode unir células para organizar melhor o cabeçalho, usando <strong>Linhas</strong> ou <strong>Colunas</strong>, de forma semelhante ao Excel.',
                side: 'top',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-grupos"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Grupos de colunas',
                description: 'Os grupos organizam a planilha criando um título acima de um conjunto de colunas.<br><br><strong>Nome do grupo:</strong> define o título que será exibido.<br><br><strong>Quantidade de colunas:</strong> define quantas colunas ficarão abaixo desse título.<br><br><strong>Ignorar colunas:</strong> deixa algumas colunas sem grupo antes do título.',
                side: 'top',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-previsualizacao"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Pré-visualização',
                description: 'Aqui você pode conferir como o cabeçalho e os grupos ficarão na planilha.<br><br>Se o modelo ainda não tiver sido configurado, o guia exibirá um exemplo apenas para demonstração. Esse exemplo não será salvo.',
                side: 'top',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-salvar"]',
            tab: 'parametros',
            needsEstrutura: true,
            popover: {
                title: 'Salvar a estrutura',
                description: 'Se esta for a estrutura que você deseja usar, clique em <strong>Salvar</strong> para guardar o modelo.<br><br>Se estiver apenas acompanhando o guia e aparecer um exemplo, clique em <strong>Próximo</strong> ou <strong>Concluir</strong>. O exemplo não será salvo.',
                side: 'top',
                align: 'end',
                onNextClick: () => moveToTabAndNext(tourManager, 'gerar'),
            },
            onHighlighted: () => {
                bindMinimizeOnShowAviso(tourManager)

                const saveButton = document.querySelector('[data-tour="exportacao-salvar"]')
                if (!saveButton || !isTourDemoVisible() || saveButton._hdvTourDemoSaveGuard) return

                const onClick = (event) => {
                    event.preventDefault()
                    event.stopPropagation()
                    event.stopImmediatePropagation?.()
                }

                saveButton.addEventListener('click', onClick, true)
                saveButton._hdvTourDemoSaveGuard = onClick
            },
            onDeselected: () => {
                unbindMinimizeOnShowAviso(tourManager)

                const saveButton = document.querySelector('[data-tour="exportacao-salvar"]')
                if (!saveButton?._hdvTourDemoSaveGuard) return
                saveButton.removeEventListener('click', saveButton._hdvTourDemoSaveGuard, true)
                delete saveButton._hdvTourDemoSaveGuard
            },
        },
        {
            element: '[data-tour="exportacao-periodo"]',
            tab: 'gerar',
            popover: {
                title: 'Período da extração',
                description: 'Aqui você define apenas o período dos dados que serão buscados. Informe a <strong>data inicial</strong> e <strong>final</strong> e, se necessário, o <strong>horário de início</strong> e <strong>fim</strong>.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => moveToTabAndPrevious(tourManager, 'parametros'),
            },
        },
        {
            element: '[data-tour="exportacao-hora-inicio"], [data-tour="exportacao-hora-fim"]',
            tab: 'gerar',
            popover: {
                title: 'Horário',
                description: 'Complementa as datas. Por padrão o dia inteiro é considerado (00:00 às 23:59). Ajuste se a extração deve pegar só um turno ou um intervalo específico.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-gerar"]',
            tab: 'gerar',
            popover: {
                title: 'Gerar Relatório',
                description: 'Gera a planilha com os dados do período informado, seguindo o modelo que você configurou. Após gerar, as opções de exportação ficam disponíveis.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-excel"]',
            tab: 'gerar',
            popover: {
                title: 'Exportar Excel',
                description: 'Baixa a planilha no formato Excel, com o cabeçalho, os grupos e as colunas configurados. Use este arquivo no dia a dia.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="exportacao-pdf"]',
            tab: 'gerar',
            popover: {
                title: 'Exportar PDF',
                description: 'Gera um PDF da mesma extração, útil para arquivo ou envio. O modelo continua salvo: você pode gerar de novo em outro período sem remontar as colunas.<br><br>Se preferir só concluir o guia, use <strong>Concluir</strong>.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
    ]

    return formSteps.map((step) => ({
        ...step,
        ensureReady: async (activeTourManager) => {
            await activateTab(step.tab)
            if (typeof step.ensureItem === 'function') {
                await step.ensureItem(activeTourManager)
            }
            if (step.needsEstrutura) {
                await ensureEstruturaVisivel(activeTourManager)
            }
            if (step.element) {
                try {
                    await activeTourManager.waitForElement(step.element, 2500)
                } catch (error) {}
            }
        },
    }))
}
